import {web_search_filter_tag} from './web_search_filter_tag';
export class web_search_filter {
    public id:number;
    public name:string;
    public web_search_filter_tags:web_search_filter_tag[]=[];
}